import { Modal } from "react-bootstrap";
import HelperService from "../../Services/HelperService";
import { useState } from "react";

interface CommonModalProps {
  show: boolean;
  handleClose: () => void;
  title: string;
  url: string;
  fileTitle: string;
}

const CommonModal = ({
  show,
  handleClose,
  title,
  url,
  fileTitle,
}: CommonModalProps) => {
  const [zoom, setZoom] = useState(1);

  if (!url) return null;

  const getExtensionTarget = () => {
    const target = fileTitle || url || "";
    if (!target) return "";
    try {
      if (target.startsWith("http://") || target.startsWith("https://")) {
        const parsed = new URL(target);
        return parsed.pathname.toLowerCase();
      }
    } catch (e) {
      // ignore
    }
    return target.split("?")[0].toLowerCase();
  };

  const lowerUrl = getExtensionTarget();

  const isPdf = lowerUrl?.endsWith(".pdf") || url?.startsWith("data:application/pdf");
  const isImage =
    url?.startsWith("data:image/") ||
    url?.startsWith("blob:") ||
    lowerUrl?.endsWith(".jpg") ||
    lowerUrl?.endsWith(".jpeg") ||
    lowerUrl?.endsWith(".png") ||
    lowerUrl?.endsWith(".gif") ||
    lowerUrl?.endsWith(".webp") ||
    lowerUrl?.endsWith(".svg");
  const isVideo =
    url?.startsWith("data:video/") ||
    lowerUrl?.endsWith(".mp4") ||
    lowerUrl?.endsWith(".mov") ||
    lowerUrl?.endsWith(".avi") ||
    lowerUrl?.endsWith(".mkv");

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {(title && HelperService.titleCase(title)) || "View Document"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body
        style={{
          height: "85vh",
          background: "#f8fafc",
          overflow: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {/* ---------- PDF ---------- */}
        {isPdf ? (
          <div style={{ width: "100%", height: "80vh" }}>
            <iframe
              src={url}
              title="PDF Viewer"
              style={{
                border: "none",
                width: "100%",
                height: "100%",
                borderRadius: "8px",
              }}
            />
          </div>
        ) : isImage ? (
          /* ---------- IMAGE ---------- */
          <div
            style={{
              textAlign: "center",
              cursor: "zoom-in",
              width: "100%",
            }}
          >
            <img
              src={url}
              alt={title || "Preview"}
              onClick={() => setZoom(zoom === 1 ? 2 : 1)}
              style={{
                maxWidth: "100%",
                height: "auto",
                transform: `scale(${zoom})`,
                transition: "transform 0.3s ease",
                imageRendering: "auto", // keeps image sharp
              }}
            />

            <div
              style={{
                fontSize: "12px",
                marginTop: "8px",
                color: "#64748b",
              }}
            >
              Click image to zoom
            </div>
          </div>
        ) : isVideo ? (
          /* ---------- VIDEO ---------- */
          <video
            src={url}
            controls
            style={{
              maxWidth: "100%",
              maxHeight: "80vh",
              borderRadius: "10px",
            }}
          />
        ) : (
          <p>Unsupported file type</p>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default CommonModal;